export class ProductLineFavorites {
    public UserFavoriteId: number;
    public UserId: number;
    public ProductLineId: number;

    constructor() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/product-line.favorites.ts